//filter on mobile

let toggleFilters = "[js-toggle-filters]";
let closeFiltersBtn = "[js-close-filter-menu]";
let windowWidth = $(window).width();
let resizeTimer;

function closeFilters() {
  $(".filters").removeClass("open");
  $(toggleFilters).addClass("icon-filter").removeClass("icon-close");
  $("body").removeClass("o-hidden");
}

$(toggleFilters).on("click", function () {
  $(".filters").toggleClass("open");
  $(this).toggleClass("icon-filter").toggleClass("icon-close");
  $("body").toggleClass("o-hidden");
});

$(closeFiltersBtn).on("click", function () {
  closeFilters();
});

$(window).resize(function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function () {
    if ($(window).width() != windowWidth) {
      windowWidth = $(window).width();

      if (windowWidth > 960) {
        closeFilters();
      }
    }
  }, 250);
});
